var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeePassXc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 63.9998,
    y1: -3.314,
    x2: 63.9998,
    y2: 118.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 302.8014,
    cy: -375.5301,
    fx: 302.8014,
    fy: -375.5301,
    r: 207.2339,
    gradientTransform: "translate(-46.999 185.5275) scale(.3539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6733,
    stopColor: "#fcfcfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 311.1472,
    cy: -348.2325,
    fx: 311.1472,
    fy: -348.2325,
    r: 172.3893,
    gradientTransform: "translate(-46.999 185.5275) scale(.3539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1088,
    stopColor: "#0f0f0d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8856,
    stopColor: "#414141",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    stopColor: "#1e1e1d",
    stopOpacity: 0.6841
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9874,
    stopColor: "#0f0f0d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 316.8927,
    cy: -451.5973,
    fx: 316.8927,
    fy: -451.5973,
    r: 334.8364,
    gradientTransform: "translate(-46.999 117.9256) scale(.3539 .2026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e6b26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ab536"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 314.3875,
    cy: -453.363,
    fx: 314.3875,
    fy: -453.363,
    r: 65.3925,
    gradientTransform: "translate(-46.999 185.5275) scale(.3539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ab536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e6b26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 322.2128,
    cy: -390.2547,
    fx: 322.2128,
    fy: -390.2547,
    r: 96.5851,
    gradientTransform: "translate(-44.2199 256.5751) scale(.3356 .5572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    stopColor: "#4f4f4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 312.9946,
    cy: -473.0178,
    fx: 312.9946,
    fy: -473.0178,
    r: 223.5101,
    gradientTransform: "translate(-46.999 185.5275) scale(.3539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    stopColor: "#f2f2f2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m63.9999,124.9c-33.5805,0-60.9001-27.3198-60.9001-60.9S30.4194,3.1,63.9999,3.1s60.8999,27.3195,60.8999,60.9-27.3193,60.9-60.8999,60.9Zm0-116.6759c-30.7415,0-55.7515,25.021-55.7515,55.7759s25.01,55.7759,55.7515,55.7759,55.7512-25.0212,55.7512-55.7759S94.7414,8.2241,63.9999,8.2241Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "m63.9999,3.1238C30.4325,3.1238,3.1236,30.4327,3.1236,64s27.3089,60.8762,60.8763,60.8762,60.8761-27.3091,60.8761-60.8762S97.5674,3.1238,63.9999,3.1238Z",
    style: {
      fill: "url(#g)",
      mixBlendMode: "lighten",
      opacity: 0.32,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m63.9999,124.9c-33.5805,0-60.9001-27.3198-60.9001-60.9S30.4194,3.1,63.9999,3.1s60.8999,27.3195,60.8999,60.9-27.3193,60.9-60.8999,60.9Zm0-116.6759c-30.7415,0-55.7515,25.021-55.7515,55.7759s25.01,55.7759,55.7515,55.7759,55.7512-25.0212,55.7512-55.7759S94.7414,8.2241,63.9999,8.2241Z",
    style: {
      fill: "url(#i)",
      opacity: 0.44,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m63.9999,8.5504c-30.9783,0-56.1809,25.2025-56.1809,56.1808s25.2025,56.1808,56.1809,56.1808,56.1807-25.2028,56.1807-56.1808S94.9783,8.5504,63.9999,8.5504Z",
    style: {
      fill: "rgba(15,15,13,.35)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m63.9999,124.9c-33.5805,0-60.9001-27.3198-60.9001-60.9S30.4194,3.1,63.9999,3.1s60.8999,27.3195,60.8999,60.9-27.3193,60.9-60.8999,60.9Zm0-120.4966C30.4195,4.4034,3.0998,31.3596,3.0998,64.4932s27.3197,60.0898,60.9001,60.0898,60.8999-26.9565,60.8999-60.0898S97.5804,4.4034,64,4.4034Z",
    style: {
      fill: "#0f0f0d",
      opacity: 0.35,
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "m63.9999,8.2241c-30.7551,0-55.776,25.0209-55.776,55.7759s25.0209,55.7759,55.776,55.7759,55.7758-25.0211,55.7758-55.7759S94.755,8.2241,63.9999,8.2241Z",
    style: {
      fill: "url(#n)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "m63.9998,12.8613c-9.1608,0-16.6136,7.4528-16.6136,16.6135s7.4528,16.6135,16.6136,16.6135,16.6135-7.4528,16.6135-16.6135-7.4527-16.6135-16.6135-16.6135Z",
    style: {
      fill: "url(#p)",
      mixBlendMode: "lighten",
      opacity: 0.7,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "m34.6871,16.3645c-.0027.0191-.0054.0378-.0081.0569-.0725.0136-.0736-.0037.0081-.0569Zm42.1177,35.8001l-.7714,13.7822,9.1023,9.9165-9.1023,9.9165,6.0168,6.5549-6.0168,6.5549.7714,13.6696h-25.61v-60.3946c-10.1823-5.2104-17.1248-16.4714-17.1248-29.4132,0-2.1659.3032-4.1671.609-6.33,1.1046-.2082,18.9673-7.6947,18.9673-7.6947-.1483.8092,20.8551.8092,20.7068,0,0,0,17.2577,7.4257,18.9891,7.7899.438,2.1264.5873,4.101.5873,6.2348,0,12.9418-7.0968,24.2029-17.1248,29.4133Zm16.5077-35.8001c.0108.0511.0194.1011.0299.1521.1896.0399.196-.0035-.0299-.1521Z",
    style: {
      fill: "url(#r)",
      mixBlendMode: "multiply",
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "m34.1161,100.4319c-9.8977-8.6081-16.164-21.2969-16.164-35.4968,0-16.5227,8.6409-31.7744,22.8728-40.29-.2541,1.6523-.5083,3.1774-.5083,4.8297,0,9.7865,5.7182,18.302,14.1049,22.2421v44.6113l10.5469,10.5491,10.5469-10.5491-.6354-9.2781,4.9558-4.9568-4.9558-4.9568,7.4972-7.4988-7.4972-7.4988.6354-10.422c8.2596-3.94,14.1049-12.4556,14.1049-22.2421,0-1.6523-.1271-3.1774-.5083-4.8297,5.1643,3.1178,9.5922,7.1416,13.1419,11.7972-8.5841-11.7889-22.5293-19.4587-38.2766-19.4587-26.0911,0-47.2421,21.05-47.2421,47.0165,0,14.693,6.7736,27.8101,17.3809,36.4318Zm27.4214-7.6624h-3.558v-35.2061h3.558v35.2061Zm-5.0828-73.9708c2.7956-.5084,5.7182-.7626,8.5138-.7626,2.9226-.1271,5.7182.2542,8.5138.7626.1271.6355.2542,1.271.2542,1.9064,0,4.8297-3.9392,8.7698-8.7679,8.7698s-8.7679-3.94-8.7679-8.7698c0-.6355.1271-1.2709.2542-1.9064Z",
    style: {
      fill: "#0f0f0d",
      mixBlendMode: "multiply",
      opacity: 0.2,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "m63.9999,8.2241c-30.7415,0-55.7514,25.0209-55.7514,55.7759s25.01,55.7759,55.7514,55.7759,55.7512-25.0212,55.7512-55.7759S94.7414,8.2241,63.9999,8.2241Zm-8.5138,9.5882c2.7956-.5084,5.7182-.7626,8.5138-.7626,2.9226-.1271,5.7182.2542,8.5138.7626.1271.6355.2542,1.271.2542,1.9064,0,4.8297-3.9392,8.7698-8.7679,8.7698s-8.7679-3.94-8.7679-8.7698c0-.6355.1271-1.2709.2542-1.9064Zm5.0828,38.7648v35.2061h-3.558v-35.2061h3.558Zm3.4309,54.3978c-25.9225,0-47.0163-20.9711-47.0163-47.0261,0-16.5227,8.6409-31.7744,22.8728-40.29-.2541,1.6523-.5083,3.1774-.5083,4.8297,0,9.7865,5.7182,18.302,14.1049,22.2421v44.6113l10.5469,10.5491,10.5469-10.5491-.6354-9.2781,4.9558-4.9568-4.9558-4.9568,7.4972-7.4988-7.4972-7.4988.6354-10.422c8.2596-3.94,14.1049-12.4556,14.1049-22.2421,0-1.6523-.1271-3.1774-.5083-4.8297,14.1049,8.5156,22.7457,23.7673,22.8728,40.29,0,25.9279-20.9668,47.0261-47.0163,47.0261Z",
    style: {
      fill: "url(#u)",
      strokeWidth: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeePassXc);
export default __webpack_public_path__ + "static/media/KeePassXC.3a574d80068be8e61d91a12e80d2f615.svg";
export { ForwardRef as ReactComponent };